import { Button } from "@material-ui/core";
import React from "react";

interface UploadButtonProps {
  onChange: (arg0: any) => void;
  classes?: {
    buttonClass?: any;
    lableClass?: any;
  };
  buttonProps?: {
    variant?: "text" | "outlined" | "contained" | undefined;
    color?: "inherit" | "primary" | "secondary" | "default" | undefined;
    component?: "span" | "button" | "div";
    disabled?: boolean;
    endIcon?: any;
    fullWidth?: boolean;
  };
  labelItem: any;
  id: string;
  customComponent?: React.ReactNode;
}

export const UploadButton = (props: UploadButtonProps) => {
  const {
    onChange,
    classes,
    labelItem,
    buttonProps,
    id,
    customComponent
  } = props;
  const { buttonClass, lableClass } = classes || {};
  return (
    <>
      <input
        style={{
          display: "none"
        }}
        id={id}
        multiple
        type="file"
        onChange={onChange}
        onClick={(event: React.MouseEvent<HTMLInputElement, MouseEvent>) => {
          const element = event.target as HTMLInputElement;
          element.value = "";
        }}
      />
      <label htmlFor={id} className={lableClass}>
        {customComponent || (
          <Button
            variant={buttonProps?.variant || "contained"}
            color={buttonProps?.color || "primary"}
            component={buttonProps?.component || "span"}
            className={buttonClass}
            disabled={buttonProps?.disabled}
            endIcon={buttonProps?.endIcon}
            fullWidth={buttonProps?.fullWidth}
          >
            {labelItem}
          </Button>
        )}
      </label>
    </>
  );
};
